import { StateEnum, StateSliceState } from 'src/store/reducers/state/types';

export const createInitialState = (): StateSliceState => ({
  state: StateEnum.COMPLETE
});
